import { hexToHSL } from "@/lib/utils/devTools/hexToHsl";

const useLightOrDarkText = (hex: string) => {
  const { l } = hexToHSL(hex.replace("#", ""));
  return l < 50 ? "light" : "dark";
};

export default useLightOrDarkText;
